export * as listView from "./listView";
export { initMainPage } from "./mainPage";

export const initAnimalImport = (...args: Parameters<typeof import("./animalImport").initAnimalImport>) =>
    import("./animalImport").then((module) => module.initAnimalImport(...args));

export const initAnimalHousingCostList = (
    ...args: Parameters<typeof import("./animalHousingCostList").initAnimalHousingCostList>
) => import("./animalHousingCostList").then((module) => module.initAnimalHousingCostList(...args));

export const initCageHousingCostList = (
    ...args: Parameters<typeof import("./cageHousingCostList").initCageHousingCostList>
) => import("./cageHousingCostList").then((module) => module.initCageHousingCostList(...args));

export const initBuildingMap = (...args: Parameters<typeof import("./buildingMap").initBuildingMap>) =>
    import("./buildingMap").then((module) => module.initBuildingMap(...args));

export const initColonyPedigree = (...args: Parameters<typeof import("./colonyPedigree").initColonyPedigree>) =>
    import("./colonyPedigree").then((module) => module.initColonyPedigree(...args));

export const initColorRules = (...args: Parameters<typeof import("./colorRules").initColorRules>) =>
    import("./colorRules").then((module) => module.initColorRules(...args));

export const initCageCategoryList = (...args: Parameters<typeof import("./cageCategoryList").initCageCategoryList>) =>
    import("./cageCategoryList").then((module) => module.initCageCategoryList(...args));

export const initCommentAttributeList = (
    ...args: Parameters<typeof import("./commentAttributeList").initCommentAttributeList>
) => import("./commentAttributeList").then((module) => module.initCommentAttributeList(...args));

export const initCostElementList = (...args: Parameters<typeof import("./costElementList").initCostElementList>) =>
    import("./costElementList").then((module) => module.initCostElementList(...args));

export const initDeviceCategoryList = (
    ...args: Parameters<typeof import("./deviceCategoryList").initDeviceCategoryList>
) => import("./deviceCategoryList").then((module) => module.initDeviceCategoryList(...args));

export const initBudgetList = (...args: Parameters<typeof import("./budgetList").initBudgetList>) =>
    import("./budgetList").then((module) => module.initBudgetList(...args));

export const initDeviceEventCategoryList = (
    ...args: Parameters<typeof import("./deviceEventCategoryList").initDeviceEventCategoryList>
) => import("./deviceEventCategoryList").then((module) => module.initDeviceEventCategoryList(...args));

export const initDrugCategoryList = (...args: Parameters<typeof import("./drugCategoryList").initDrugCategoryList>) =>
    import("./drugCategoryList").then((module) => module.initDrugCategoryList(...args));

export const initExternalOrderingCostList = (
    ...args: Parameters<typeof import("./externalOrderingCostList").initExternalOrderingCostList>
) => import("./externalOrderingCostList").then((module) => module.initExternalOrderingCostList(...args));

export const initFacilityList = (...args: Parameters<typeof import("./facilityList").initFacilityList>) =>
    import("./facilityList").then((module) => module.initFacilityList(...args));

export const initGeneticBackgroundList = (
    ...args: Parameters<typeof import("./geneticBackgroundList").initGeneticBackgroundList>
) => import("./geneticBackgroundList").then((module) => module.initGeneticBackgroundList(...args));

export const initGradeList = (...args: Parameters<typeof import("./mutationGradeList").initGradeList>) =>
    import("./mutationGradeList").then((module) => module.initGradeList(...args));

export const initInternalOrderCostList = (
    ...args: Parameters<typeof import("./internalOrderCostList").initInternalOrderCostList>
) => import("./internalOrderCostList").then((module) => module.initInternalOrderCostList(...args));

export const initLicenseTypeList = (...args: Parameters<typeof import("./licenseTypeList").initLicenseTypeList>) =>
    import("./licenseTypeList").then((module) => module.initLicenseTypeList(...args));

export const initMedicalConditionList = (
    ...args: Parameters<typeof import("./medicalConditionList").initMedicalConditionList>
) => import("./medicalConditionList").then((module) => module.initMedicalConditionList(...args));

export const initMutationTypeList = (...args: Parameters<typeof import("./mutationTypeList").initMutationTypeList>) =>
    import("./mutationTypeList").then((module) => module.initMutationTypeList(...args));

export const initOrderRequestCatalogImport = (
    ...args: Parameters<typeof import("./orderRequestCatalogImport").initOrderRequestCatalogImport>
) => import("./orderRequestCatalogImport").then((module) => module.initOrderRequestCatalogImport(...args));

export const initOrderRequestCatalogItemList = (
    ...args: Parameters<typeof import("./orderRequestCatalogItemList").initOrderRequestCatalogItemList>
) => import("./orderRequestCatalogItemList").then((module) => module.initOrderRequestCatalogItemList(...args));

export const initOrderRequestCatalogList = (
    ...args: Parameters<typeof import("./orderRequestCatalogList").initOrderRequestCatalogList>
) => import("./orderRequestCatalogList").then((module) => module.initOrderRequestCatalogList(...args));

export const initPriceCategoryList = (
    ...args: Parameters<typeof import("./priceCategoryList").initPriceCategoryList>
) => import("./priceCategoryList").then((module) => module.initPriceCategoryList(...args));

export const initPricePeriodList = (...args: Parameters<typeof import("./pricePeriodList").initPricePeriodList>) =>
    import("./pricePeriodList").then((module) => module.initPricePeriodList(...args));

export const initProjectCategoryList = (
    ...args: Parameters<typeof import("./projectCategoryList").initProjectCategoryList>
) => import("./projectCategoryList").then((module) => module.initProjectCategoryList(...args));

export const initProcedureList = (...args: Parameters<typeof import("./procedureList").initProcedureList>) =>
    import("./procedureList").then((module) => module.initProcedureList(...args));

export const initPyratStatusReport = (
    ...args: Parameters<typeof import("./pyratStatus/report").initPyratStatusReport>
) => import("./pyratStatus/report").then((module) => module.initPyratStatusReport(...args));

export const initPyratStatusSettings = (
    ...args: Parameters<typeof import("./pyratStatus/settings").initPyratStatusSettings>
) => import("./pyratStatus/settings").then((module) => module.initPyratStatusSettings(...args));

export const initPyratStatusTrend = (...args: Parameters<typeof import("./pyratStatus/trend").initPyratStatusTrend>) =>
    import("./pyratStatus/trend").then((module) => module.initPyratStatusTrend(...args));

export const initSacrificeMethodList = (
    ...args: Parameters<typeof import("./sacrificeMethodList").initSacrificeMethodList>
) => import("./sacrificeMethodList").then((module) => module.initSacrificeMethodList(...args));

export const initSacrificeReasonList = (
    ...args: Parameters<typeof import("./sacrificeReasonList").initSacrificeReasonList>
) => import("./sacrificeReasonList").then((module) => module.initSacrificeReasonList(...args));

export const initServiceCategoryList = (
    ...args: Parameters<typeof import("./serviceCategoryList").initServiceCategoryList>
) => import("./serviceCategoryList").then((module) => module.initServiceCategoryList(...args));

export const initSeverityAssessmentClinicalSignCategoryList = (
    ...args: Parameters<
        typeof import("./severityAssessmentClinicalSignCategoryList").initSeverityAssessmentClinicalSignCategoryList
    >
) =>
    import("./severityAssessmentClinicalSignCategoryList").then((module) =>
        module.initSeverityAssessmentClinicalSignCategoryList(...args),
    );

export const initSeverityAssessmentTemplateList = (
    ...args: Parameters<typeof import("./severityAssessmentTemplateList").initSeverityAssessmentTemplateList>
) => import("./severityAssessmentTemplateList").then((module) => module.initSeverityAssessmentTemplateList(...args));

export const initSeverityAssessmentClinicalSignList = (
    ...args: Parameters<typeof import("./severityAssessmentClinicalSignList").initSeverityAssessmentClinicalSignList>
) =>
    import("./severityAssessmentClinicalSignList").then((module) =>
        module.initSeverityAssessmentClinicalSignList(...args),
    );

export const initSpecialServiceCostList = (
    ...args: Parameters<typeof import("./specialServiceCostList").initSpecialServiceCostList>
) => import("./specialServiceCostList").then((module) => module.initSpecialServiceCostList(...args));

export const initProcedureCostList = (
    ...args: Parameters<typeof import("./procedureCostList").initProcedureCostList>
) => import("./procedureCostList").then((module) => module.initProcedureCostList(...args));

export const initTimePointList = (
    ...args: Parameters<typeof import("./severityAssessmentTimePointList").initTimePointList>
) => import("./severityAssessmentTimePointList").then((module) => module.initTimePointList(...args));

export const initUserCertificateTypeList = (
    ...args: Parameters<typeof import("./userCertificateTypeList").initUserCertificateTypeList>
) => import("./userCertificateTypeList").then((module) => module.initUserCertificateTypeList(...args));

export const initWorkRequestStatusList = (
    ...args: Parameters<typeof import("./workRequestStatusList").initWorkRequestStatusList>
) => import("./workRequestStatusList").then((module) => module.initWorkRequestStatusList(...args));

export const initStrainDatabaseFieldList = (
    ...args: Parameters<typeof import("./strainDatabaseFieldList").initStrainDatabaseFieldList>
) => import("./strainDatabaseFieldList").then((module) => module.initStrainDatabaseFieldList(...args));
